export const GET_BUY_BONUS_PACKAGES = `
  query GetBuyBonusPackages(
    $operatorId: String!
    $brandId: String!
    $currency: String!
    $gameCode: String!
  ) {
    players {
      getBuyBonusPackages(
        operatorId: $operatorId
        brandId: $brandId
        currency: $currency
        gameCode: $gameCode
      ) {
        status
        success
        message
        code
        data {
          count
          buyBonusPackages {
            operatorId
            brandId
            currency
            gameCode
            packageId
            packageName
            status
            numberOfFreebets
            stakeAmountPerFreebet
            packageValue
            slabOrder
            jackpotRatio
          }
        }
      }
    }
  }
`

export const BUY_BONUS_PACKAGE = `
  mutation BuyBonusPackage(
    $playerId: String!
    $token: String!
    $operatorId: String!
    $brandId: String!
    $currency: String!
    $gameCode: String!
    $packageValue: Float!
    $packageId: String!
    $gameMode: String
  ) {
    players {
      buyBonusPackage(
        playerId: $playerId
        token: $token
        operatorId: $operatorId
        brandId: $brandId
        currency: $currency
        gameCode: $gameCode
        packageValue: $packageValue
        packageId: $packageId
        gameMode: $gameMode
      ) {
        status
        success
        message
        code
        data {
          playerId
          balance
          currency
          packageValue
          packageId
        }
      }
    }
  }
`
